import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=70b80595&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=70b80595&prod&scoped=true&lang=css"
import style1 from "./Pricing.vue?vue&type=style&index=1&id=70b80595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b80595",
  null
  
)

export default component.exports